import React, { useCallback, useEffect, useRef, useState } from "react";
import { axiosRequest } from "../../utility/axios";
import { maskPhone } from "../../helper";

const API_URL = process.env.REACT_APP_API_URL;
const AUTH_KEY = "leaderboard_auth";
// Table Type = game format; Table Value = stake. Used to be one combined field
// (table_type held the stake directly) -- now split so PLO/ROE (a format, not a
// stake) can be recorded alongside which stake the table is actually playing.
const TABLE_TYPES = ["PLO", "ROE"];
const TABLE_VALUES = ["100/200", "100/200/500", "200/500/1000", "500/1000", "500/1000/2000"];
const TABLE_NUMBERS = ["1", "2", "3", "4", "5", "6", "7", "8"];
const TABLE_CAPACITY = 9;
// Mirrors dao/leaderboardEntry.js TABLE_MULTIPLIERS — display only, points are computed server-side.
const TABLE_MULTIPLIERS = { "100/200": 1, "100/200/500": 1.25, "200/500/1000": 1.5, "500/1000": 1.75, "500/1000/2000": 2 };

const CSS = `
*,*::before,*::after{box-sizing:border-box;}
.lb-root{min-height:100vh;min-height:100dvh;background:#0f1115;color:#f2f2f2;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;padding-bottom:88px;}
.lb-header{position:sticky;top:0;z-index:20;background:#161922;border-bottom:1px solid #262a36;padding:14px 16px;display:flex;align-items:center;justify-content:space-between;}
.lb-header h1{font-size:17px;font-weight:700;letter-spacing:.3px;margin:0;display:flex;align-items:center;gap:8px;}
.lb-staff{font-size:12px;color:#9aa0ac;}
.lb-logout{background:none;border:1px solid #333846;color:#c9cdd6;font-size:12px;padding:6px 10px;border-radius:8px;}
.lb-tabs{position:sticky;top:53px;z-index:19;display:flex;background:#12141b;border-bottom:1px solid #262a36;overflow-x:auto;}
.lb-tab{flex:1;min-width:84px;text-align:center;padding:11px 6px;font-size:12.5px;font-weight:600;color:#8b8f99;border-bottom:2px solid transparent;white-space:nowrap;}
.lb-tab.active{color:#4fd1c5;border-color:#4fd1c5;}
.lb-body{padding:16px;max-width:640px;margin:0 auto;}
.lb-card{background:#1a1d27;border:1px solid #262a36;border-radius:14px;padding:16px;margin-bottom:14px;}
.lb-field{margin-bottom:14px;}
.lb-field label{display:block;font-size:12.5px;color:#a6abb6;margin-bottom:6px;font-weight:600;}
.lb-input,.lb-select{width:100%;padding:13px 12px;border-radius:10px;border:1px solid #333846;background:#12141b;color:#f2f2f2;font-size:16px;-webkit-appearance:none;appearance:none;}
.lb-input:focus,.lb-select:focus{outline:none;border-color:#4fd1c5;}
.lb-input:disabled{opacity:.55;}
.lb-field-hint{font-size:12px;margin-top:6px;color:#9aa0ac;}
.lb-hint-ok{color:#7be0a0;font-weight:600;}
.lb-hint-err{color:#ff8a8a;font-weight:600;}
.lb-row2{display:grid;grid-template-columns:1fr 1fr;gap:10px;}
.lb-btn{width:100%;padding:14px;border-radius:12px;border:none;font-size:15.5px;font-weight:700;cursor:pointer;}
.lb-btn-primary{background:#4fd1c5;color:#08201d;}
.lb-btn-primary:disabled{opacity:.5;}
.lb-btn-ghost{background:transparent;border:1px solid #333846;color:#e5e7eb;}
.lb-btn-danger{background:#3a1a1f;color:#ff8a8a;border:1px solid #5c2530;}
.lb-suggest{position:relative;}
.lb-suggest-list{position:absolute;left:0;right:0;top:calc(100% + 4px);background:#1f232f;border:1px solid #333846;border-radius:10px;max-height:220px;overflow-y:auto;z-index:30;}
.lb-suggest-item{padding:11px 12px;font-size:14px;border-bottom:1px solid #262a36;}
.lb-suggest-item:last-child{border-bottom:none;}
.lb-suggest-item b{color:#4fd1c5;}
.lb-suggest-sub{font-size:12px;color:#9aa0ac;}
.lb-entry{background:#1a1d27;border:1px solid #262a36;border-radius:12px;padding:12px 14px;margin-bottom:10px;}
.lb-entry-top{display:flex;justify-content:space-between;align-items:flex-start;gap:8px;}
.lb-entry-player{font-weight:700;font-size:15px;}
.lb-entry-sub{font-size:12px;color:#9aa0ac;margin-top:2px;}
.lb-chip{display:inline-block;font-size:11px;padding:3px 8px;border-radius:100px;background:#20364f;color:#7ec8ff;font-weight:600;}
.lb-chip-live{background:#1f3a2c;color:#7be0a0;}
.lb-chip-break{background:#3a2f1a;color:#ffcf7b;}
.lb-entry-meta{display:flex;gap:14px;margin-top:8px;font-size:12.5px;color:#c3c7d1;flex-wrap:wrap;align-items:center;}
.lb-entry-actions{display:flex;gap:8px;margin-top:10px;flex-wrap:wrap;}
.lb-entry-actions button{flex:1 1 auto;min-width:calc(50% - 4px);padding:9px;border-radius:9px;font-size:12.5px;font-weight:700;border:none;}
.lb-act-edit{background:#262a36;color:#e5e7eb;}
.lb-act-del{background:#3a1a1f;color:#ff8a8a;}
.lb-act-checkout{background:#4fd1c5;color:#08201d;}
.lb-act-break{background:#3a2f1a;color:#ffcf7b;border:1px solid #5c4a25;}
.lb-act-break.on-break{background:#ffcf7b;color:#3a2f1a;}
.lb-empty{text-align:center;color:#7d818c;padding:40px 10px;font-size:14px;}
.lb-toast{position:fixed;left:50%;bottom:20px;transform:translateX(-50%);background:#262a36;color:#fff;padding:11px 18px;border-radius:10px;font-size:13.5px;z-index:100;box-shadow:0 8px 24px rgba(0,0,0,.4);max-width:90vw;text-align:center;}
.lb-toast.err{background:#4a1c22;color:#ffb3b3;}
.lb-rank-row{display:flex;align-items:center;gap:12px;background:#1a1d27;border:1px solid #262a36;border-radius:12px;padding:12px 14px;margin-bottom:8px;}
.lb-rank-num{font-size:16px;font-weight:800;color:#4fd1c5;width:26px;text-align:center;}
.lb-rank-num.gold{color:#ffd700;}
.lb-rank-num.silver{color:#c8c8d8;}
.lb-rank-num.bronze{color:#cd8a4a;}
.lb-rank-info{flex:1;}
.lb-rank-name{font-weight:700;font-size:14.5px;}
.lb-rank-sub{font-size:11.5px;color:#9aa0ac;margin-top:2px;}
.lb-rank-time{font-weight:800;font-size:15px;color:#f2f2f2;white-space:nowrap;}
.lb-rules-card{padding-top:14px;}
.lb-rules-title{font-size:13.5px;font-weight:700;color:#e5e7eb;margin-bottom:10px;}
.lb-rules-mult{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:10px;}
.lb-rules-note{font-size:11.5px;color:#9aa0ac;}
.lb-login-wrap{min-height:100vh;min-height:100dvh;display:flex;align-items:center;justify-content:center;background:#0f1115;padding:20px;}
.lb-login-card{background:#1a1d27;border:1px solid #262a36;border-radius:18px;padding:28px 22px;width:100%;max-width:360px;}
.lb-login-card h1{text-align:center;font-size:19px;margin:0 0 4px;}
.lb-login-card p{text-align:center;color:#9aa0ac;font-size:12.5px;margin:0 0 22px;}
.lb-login-err{color:#ff8a8a;font-size:12.5px;text-align:center;margin-top:10px;}
.lb-fab-bar{position:fixed;left:0;right:0;bottom:0;padding:12px 16px calc(12px + env(safe-area-inset-bottom));background:linear-gradient(0deg,#0f1115 60%,transparent);z-index:25;}
.lb-fab-bar .lb-btn{max-width:640px;margin:0 auto;display:block;}
.lb-modal-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:40;display:flex;align-items:flex-end;justify-content:center;}
.lb-modal{background:#161922;border-radius:18px 18px 0 0;padding:20px 18px calc(20px + env(safe-area-inset-bottom));width:100%;max-width:640px;}
.lb-modal h3{margin:0 0 14px;font-size:16px;}
.lb-filters{display:flex;gap:8px;overflow-x:auto;margin-bottom:12px;padding-bottom:2px;}
.lb-filters select,.lb-filters input{flex:0 0 auto;padding:9px 10px;font-size:13px;border-radius:9px;border:1px solid #333846;background:#12141b;color:#f2f2f2;}
.lb-table-bar{display:flex;gap:8px;overflow-x:auto;margin-bottom:12px;padding-bottom:2px;}
.lb-table-btn{flex:0 0 auto;padding:10px 16px;font-size:13px;font-weight:700;border-radius:10px;border:1px solid #333846;background:#161922;color:#c9cdd6;white-space:nowrap;}
.lb-table-btn.active{background:#4fd1c5;color:#08201d;border-color:#4fd1c5;}
.lb-table-live-banner{display:flex;align-items:center;justify-content:space-between;gap:10px;background:#1f3a2c;border:1px solid #2d5a3f;
  border-radius:10px;padding:10px 14px;margin-bottom:12px;font-size:13px;color:#7be0a0;font-weight:700;}
.lb-table-live-banner button{background:none;border:1px solid #7be0a0;color:#7be0a0;font-size:12px;font-weight:600;padding:6px 10px;border-radius:8px;}
.lb-table-live-banner.full{background:#3a2320;border-color:#5c3530;color:#ff9a7b;}
.lb-seatmap{display:grid;grid-template-columns:repeat(5,1fr);gap:8px;margin-bottom:16px;}
.lb-seat{border-radius:10px;padding:9px 6px;text-align:center;border:1px solid #333846;background:#161922;}
.lb-seat-num{font-size:11px;font-weight:800;color:#8b8f99;letter-spacing:.3px;}
.lb-seat-name{font-size:11px;font-weight:700;margin-top:3px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.lb-seat-0{opacity:.6;}
.lb-seat-0 .lb-seat-num{color:#8b8f99;}
.lb-seat-1{background:#3a2f1a;border-color:#5c4a25;}
.lb-seat-1 .lb-seat-num,.lb-seat-1 .lb-seat-name{color:#ffcf7b;}
.lb-seat-2{background:#1f3a2c;border-color:#2d5a3f;}
.lb-seat-2 .lb-seat-num,.lb-seat-2 .lb-seat-name{color:#7be0a0;}
.lb-seatmap-legend{display:flex;gap:14px;flex-wrap:wrap;margin-bottom:14px;font-size:11px;color:#9aa0ac;}
.lb-seatmap-legend span{display:inline-flex;align-items:center;gap:5px;}
.lb-seatmap-legend i{width:9px;height:9px;border-radius:3px;display:inline-block;}
.lb-checkbox-field{display:flex;align-items:center;gap:9px;background:#12141b;border:1px solid #333846;border-radius:10px;padding:12px;margin-bottom:14px;}
.lb-checkbox-field input{width:18px;height:18px;flex:0 0 auto;}
.lb-checkbox-field label{font-size:13.5px;font-weight:600;color:#e5e7eb;margin:0;}
.lb-capacity-hint{font-size:12px;margin-top:-6px;margin-bottom:14px;color:#9aa0ac;}
.lb-capacity-hint.full{color:#ff9a7b;font-weight:600;}
.lb-section-title{font-size:12.5px;font-weight:700;color:#8b8f99;text-transform:uppercase;letter-spacing:.4px;margin:18px 0 8px;}
.lb-wait-row{display:flex;align-items:center;justify-content:space-between;gap:10px;background:#241f14;border:1px solid #5c4a25;border-radius:12px;padding:11px 14px;margin-bottom:8px;}
.lb-wait-info{flex:1;}
.lb-wait-name{font-weight:700;font-size:14px;}
.lb-wait-sub{font-size:11.5px;color:#c9b98a;margin-top:2px;}
.lb-wait-pos{font-size:11px;font-weight:800;color:#ffcf7b;background:#3a2f1a;border-radius:100px;padding:2px 9px;margin-right:8px;}
.lb-act-seat{background:#ffcf7b;color:#3a2f1a;border:none;padding:8px 12px;border-radius:9px;font-size:12.5px;font-weight:700;white-space:nowrap;}
`;

const pad = (n) => String(n).padStart(2, "0");
const IST_TZ = "Asia/Kolkata";
const IST_OFFSET_MIN = 5 * 60 + 30;
// Every device viewing/entering data here should read the same IST wall-clock time
// regardless of its own system timezone — these two are inverses of each other.
const toInputValue = (d) => {
  const dt = d ? new Date(d) : new Date();
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: IST_TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(dt);
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const hour = get("hour") === "24" ? "00" : get("hour");
  return `${get("year")}-${get("month")}-${get("day")}T${hour}:${get("minute")}`;
};
const fromInputValue = (s) => {
  if (!s) return null;
  const [datePart, timePart] = s.split("T");
  const [y, mo, d] = datePart.split("-").map(Number);
  const [h, mi] = timePart.split(":").map(Number);
  const base = Date.UTC(y, mo - 1, d, 0, 0, 0, 0);
  return new Date(base + (h * 60 + mi - IST_OFFSET_MIN) * 60000);
};
const fmtTime = (d) => (d ? new Date(d).toLocaleString("en-IN", { timeZone: IST_TZ, day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "--");
const fmtDuration = (mins) => {
  const m = Math.max(0, Math.round(mins));
  const h = Math.floor(m / 60);
  const r = m % 60;
  return h > 0 ? `${h}h ${r}m` : `${r}m`;
};
const fmtPoints = (p) => {
  const n = Math.round((p || 0) * 10) / 10;
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
};

const emptyForm = () => ({
  player_id: "",
  table_type: TABLE_TYPES[0],
  table_value: TABLE_VALUES[0],
  table_number: TABLE_NUMBERS[0],
  seat_number: "",
  in_time: toInputValue(),
  out_time: "",
  break_minutes: "0",
  remarks: "",
  // New entries default to "assigned, not seated yet" -- staff use Seat Now to confirm
  // once the player is physically at the table, same as the seat map's status 1 -> 2.
  is_waiting: true,
});

export default function LeaderboardPage() {
  const [auth, setAuth] = useState(() => {
    try { return JSON.parse(localStorage.getItem(AUTH_KEY) || "null"); } catch { return null; }
  });
  const [pin, setPin] = useState("");
  const [staffName, setStaffName] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginErr, setLoginErr] = useState("");

  const [tab, setTab] = useState("entry");
  const [toast, setToast] = useState(null); // {msg, err}
  const toastTimer = useRef(null);

  const showToast = useCallback((msg, err = false) => {
    setToast({ msg, err });
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 2800);
  }, []);

  const api = useCallback(
    async (method, path, data) => {
      const res = await axiosRequest(method, `${API_URL}${path}`, null, data, auth?.token ? { leaderboard_token: auth.token } : {});
      const httpStatus = res?.response?.status;
      if (httpStatus === 401 || httpStatus === 403) {
        localStorage.removeItem(AUTH_KEY);
        setAuth(null);
        // Surface a specific server reason (e.g. IP restriction) when one is given.
        const serverMsg = res?.response?.data?.error;
        return {
          ok: false,
          error: serverMsg && httpStatus === 403 ? serverMsg : "Session expired, please log in again",
        };
      }
      if (!res || !res.data) {
        return { ok: false, error: res?.response?.data?.error || res?.message || "Network error" };
      }
      return { ok: true, payload: res.data };
    },
    [auth]
  );

  // ── Login ──
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!pin.trim()) return;
    setLoginLoading(true);
    setLoginErr("");
    const { ok, payload, error } = await api("post", "/leaderboard/login", { pin: pin.trim(), staff_name: staffName.trim() });
    setLoginLoading(false);
    if (!ok) return setLoginErr(error || "Login failed");
    if (!payload?.status) return setLoginErr(payload?.message || "Invalid PIN");
    const next = { token: payload.token, staff_name: payload.staff_name || staffName.trim() };
    localStorage.setItem(AUTH_KEY, JSON.stringify(next));
    setAuth(next);
  };

  const handleLogout = () => {
    localStorage.removeItem(AUTH_KEY);
    setAuth(null);
  };

  if (!auth?.token) {
    return (
      <div className="lb-root">
        <style>{CSS}</style>
        <div className="lb-login-wrap">
          <div className="lb-login-card">
            <h1>🏆 Table Leaderboard</h1>
            <p>Staff entry — enter the shared PIN to continue</p>
            <form onSubmit={handleLogin}>
              <div className="lb-field">
                <label>Your name (optional)</label>
                <input className="lb-input" value={staffName} onChange={(e) => setStaffName(e.target.value)} placeholder="e.g. Rahul" />
              </div>
              <div className="lb-field">
                <label>PIN</label>
                <input className="lb-input" type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="Enter PIN" autoFocus />
              </div>
              <button className="lb-btn lb-btn-primary" disabled={loginLoading} type="submit">
                {loginLoading ? "Checking..." : "Enter"}
              </button>
              {loginErr && <div className="lb-login-err">{loginErr}</div>}
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="lb-root">
      <style>{CSS}</style>
      <header className="lb-header">
        <h1>🏆 Leaderboard</h1>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {auth.staff_name && <span className="lb-staff">{auth.staff_name}</span>}
          <button className="lb-logout" onClick={handleLogout}>Log out</button>
        </div>
      </header>
      <nav className="lb-tabs">
        {[
          ["entry", "New Entry"],
          ["history", "History"],
          ["rankings", "Rankings"],
        ].map(([id, label]) => (
          <div key={id} className={`lb-tab${tab === id ? " active" : ""}`} onClick={() => setTab(id)}>
            {label}
          </div>
        ))}
      </nav>
      <div className="lb-body">
        {tab === "entry" && <EntryTab api={api} showToast={showToast} />}
        {tab === "history" && <HistoryTab api={api} showToast={showToast} />}
        {tab === "rankings" && <RankingsTab api={api} />}
      </div>
      {toast && <div className={`lb-toast${toast.err ? " err" : ""}`}>{toast.msg}</div>}
    </div>
  );
}

/* ───────────────────────── New Entry Tab ───────────────────────── */
function usePlayerLookup(api, playerId) {
  // status: 'idle' | 'checking' | 'valid' | 'invalid'
  const [status, setStatus] = useState("idle");
  const [player, setPlayer] = useState(null);
  const debounceRef = useRef(null);
  const requestSeq = useRef(0);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    const id = playerId.trim();
    if (!id) {
      setStatus("idle");
      setPlayer(null);
      return;
    }
    setStatus("checking");
    debounceRef.current = setTimeout(async () => {
      const seq = ++requestSeq.current;
      const { ok, payload } = await api("get", `/leaderboard/players/lookup?player_id=${encodeURIComponent(id)}`);
      if (seq !== requestSeq.current) return; // stale response, a newer lookup is in flight
      if (ok && payload?.found) {
        setStatus("valid");
        setPlayer(payload.player);
      } else {
        setStatus("invalid");
        setPlayer(null);
      }
    }, 400);
    return () => clearTimeout(debounceRef.current);
  }, [api, playerId]);

  return { status, player };
}

// How many seats are currently occupied on a table -- re-checked whenever the table changes.
function useTableSeatedCount(api, tableNumber, refreshKey) {
  const [seated, setSeated] = useState(null);
  useEffect(() => {
    let cancelled = false;
    setSeated(null);
    (async () => {
      const { ok, payload } = await api("get", `/leaderboard/entries?table_number=${encodeURIComponent(tableNumber)}&status=ACTIVE&size=1`);
      if (!cancelled && ok) setSeated(payload?.pagination?.total ?? null);
    })();
    return () => { cancelled = true; };
  }, [api, tableNumber, refreshKey]);
  return seated;
}

function PlayerIdStatusLine({ status, player }) {
  if (status === "checking") return <div className="lb-field-hint">Checking player ID…</div>;
  if (status === "valid") return <div className="lb-field-hint lb-hint-ok">✓ {player?.name || "Player found"}{player?.phone ? ` · ${maskPhone(player.phone)}` : ""}</div>;
  if (status === "invalid") return <div className="lb-field-hint lb-hint-err">✗ Player ID not found</div>;
  return null;
}

function EntryTab({ api, showToast }) {
  const [form, setForm] = useState(emptyForm());
  const [saving, setSaving] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggest, setShowSuggest] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  // Whether the staff member has manually edited In-Time/Waiting-Since -- until they do,
  // it auto-refreshes to "now" at submit so a form left open for a while can't submit a
  // stale timestamp and trip the same-player-overlap check against a session that's since
  // moved on.
  const [inTimeTouched, setInTimeTouched] = useState(false);
  const searchDebounceRef = useRef(null);

  const { status: playerStatus, player: matchedPlayer } = usePlayerLookup(api, form.player_id);
  const seatedCount = useTableSeatedCount(api, form.table_number, refreshKey);
  const tableFull = seatedCount != null && seatedCount >= TABLE_CAPACITY;

  // Can't mark someone as immediately/directly seated at a table that has no open seat --
  // lock the "not seated yet" checkbox on so submit can't hit that backend rejection.
  useEffect(() => {
    if (tableFull) setForm((f) => (f.is_waiting ? f : { ...f, is_waiting: true }));
  }, [tableFull]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const setChecked = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.checked }));
  const setInTime = (e) => { setInTimeTouched(true); setForm((f) => ({ ...f, in_time: e.target.value })); };

  const searchPlayers = (q) => {
    clearTimeout(searchDebounceRef.current);
    if (q.trim().length < 2) return setSuggestions([]);
    searchDebounceRef.current = setTimeout(async () => {
      const { ok, payload } = await api("get", `/leaderboard/players/search?q=${encodeURIComponent(q.trim())}`);
      if (ok) setSuggestions(payload?.players || []);
    }, 300);
  };

  const pickSuggestion = (p) => {
    setForm((f) => ({ ...f, player_id: p.playerId || "" }));
    setSuggestions([]);
    setShowSuggest(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.player_id.trim() || !form.table_type || !form.table_value || !form.table_number || !form.in_time) {
      return showToast("Player ID, table type, table value, table number & in-time are required", true);
    }
    if (playerStatus !== "valid") {
      return showToast("Enter a valid Player ID before saving", true);
    }
    if (tableFull && !form.is_waiting) {
      return showToast(`Table ${form.table_number} is full (${TABLE_CAPACITY}/${TABLE_CAPACITY}). Check "Add to waiting list" instead.`, true);
    }
    if (form.seat_number && (Number(form.seat_number) < 1 || Number(form.seat_number) > 10)) {
      return showToast("Seat number must be between 1 and 10", true);
    }
    setSaving(true);
    // Only trust the field's own value if the staff member actually edited it -- otherwise
    // it may have gone stale sitting on screen, so re-stamp it "now" right before sending.
    const effectiveInTime = inTimeTouched ? form.in_time : toInputValue();
    const { ok, payload, error } = await api("post", "/leaderboard/entries", {
      player_id: form.player_id.trim(),
      table_type: form.table_type,
      table_value: form.table_value,
      table_number: form.table_number,
      seat_number: form.seat_number ? Number(form.seat_number) : null,
      in_time: fromInputValue(effectiveInTime).toISOString(),
      out_time: form.is_waiting ? null : (form.out_time ? fromInputValue(form.out_time).toISOString() : null),
      break_minutes: form.is_waiting ? 0 : (Number(form.break_minutes) || 0),
      remarks: form.remarks,
      is_waiting: form.is_waiting,
    });
    setSaving(false);
    if (!ok || !payload?.status) return showToast(error || payload?.message || "Could not save entry", true);
    showToast(form.is_waiting
      ? `${payload?.data?.player_name || form.player_id} assigned to Table ${form.table_number} — not seated yet`
      : `Entry saved for ${payload?.data?.player_name || form.player_id}`);
    setForm(emptyForm());
    setInTimeTouched(false);
    setRefreshKey((k) => k + 1);
  };

  return (
    <form onSubmit={submit}>
      <div className="lb-card">
        <div className="lb-field lb-suggest">
          <label>Player ID *</label>
          <input
            className="lb-input"
            value={form.player_id}
            onChange={(e) => { set("player_id")(e); searchPlayers(e.target.value); setShowSuggest(true); }}
            onFocus={() => setShowSuggest(true)}
            onBlur={() => setTimeout(() => setShowSuggest(false), 150)}
            placeholder="e.g. PLR1023"
            autoCapitalize="characters"
          />
          <PlayerIdStatusLine status={playerStatus} player={matchedPlayer} />
          {showSuggest && suggestions.length > 0 && (
            <div className="lb-suggest-list">
              {suggestions.map((p) => (
                <div key={p._id} className="lb-suggest-item" onMouseDown={() => pickSuggestion(p)}>
                  <b>{p.playerId}</b> — {p.name || "—"}
                  <div className="lb-suggest-sub">{maskPhone(p.phone) || ""}</div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="lb-field">
          <label>Player Name</label>
          <input
            className="lb-input"
            value={matchedPlayer?.name || ""}
            disabled
            placeholder={playerStatus === "checking" ? "Checking..." : "Auto-fills once Player ID is verified"}
          />
        </div>
        <div className="lb-field">
          <label>Table Type *</label>
          <select className="lb-select" value={form.table_type} onChange={set("table_type")}>
            {TABLE_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div className="lb-field">
          <label>Table Value *</label>
          <select className="lb-select" value={form.table_value} onChange={set("table_value")}>
            {TABLE_VALUES.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
        </div>
        <div className="lb-field">
          <label>Table Number *</label>
          <select className="lb-select" value={form.table_number} onChange={set("table_number")}>
            {TABLE_NUMBERS.map((n) => <option key={n} value={n}>Table {n}</option>)}
          </select>
        </div>
        <div className="lb-field">
          <label>Seat Number</label>
          <input
            className="lb-input"
            type="text"
            inputMode="numeric"
            placeholder="1-10"
            value={form.seat_number}
            onChange={(e) => {
              const v = e.target.value.replace(/[^0-9]/g, "");
              setForm((f) => ({ ...f, seat_number: v === "" ? "" : String(Math.min(10, Number(v))) }));
            }}
          />
        </div>
        <div className={`lb-capacity-hint${tableFull ? " full" : ""}`}>
          {seatedCount == null ? "Checking seats…" : tableFull ? `Table ${form.table_number} is full (${seatedCount}/${TABLE_CAPACITY} seated)` : `Table ${form.table_number}: ${seatedCount}/${TABLE_CAPACITY} seated`}
        </div>
        <div className="lb-checkbox-field">
          <input type="checkbox" id="is_waiting" checked={form.is_waiting} disabled={tableFull} onChange={setChecked("is_waiting")} />
          <label htmlFor="is_waiting">
            {tableFull
              ? "Not seated yet (table is full, so this stays checked)"
              : "Not seated yet — uncheck only if they're already physically seated"}
          </label>
        </div>
        <div className="lb-row2">
          <div className="lb-field">
            <label>{form.is_waiting ? "Waiting Since *" : "In-Time *"}</label>
            <input className="lb-input" type="datetime-local" value={form.in_time} onChange={setInTime} />
            {!inTimeTouched && <div className="lb-field-hint">Auto-set to now at save time</div>}
          </div>
          {!form.is_waiting && (
            <div className="lb-field">
              <label>Out-Time</label>
              <input className="lb-input" type="datetime-local" value={form.out_time} onChange={set("out_time")} />
            </div>
          )}
        </div>
        {!form.is_waiting && (
          <div className="lb-field">
            <label>Break (minutes)</label>
            <input className="lb-input" type="number" min="0" inputMode="numeric" value={form.break_minutes} onChange={set("break_minutes")} />
          </div>
        )}
        <div className="lb-field">
          <label>Remarks (optional)</label>
          <input className="lb-input" value={form.remarks} onChange={set("remarks")} placeholder="Any note" />
        </div>
      </div>
      <button className="lb-btn lb-btn-primary" disabled={saving || playerStatus !== "valid" || (tableFull && !form.is_waiting)} type="submit">
        {saving ? "Saving..." : "Save Entry"}
      </button>
      <p style={{ textAlign: "center", color: "#7d818c", fontSize: 12, marginTop: 10 }}>
        {form.is_waiting
          ? "Saved as assigned but not seated yet — use Seat Now once they're physically at the table."
          : "Leave Out-Time blank to check the player in now, and close it out later by editing the entry from History."}
      </p>
    </form>
  );
}

// Derived, not stored: 0 = seat has no entry at all, 1 = a waiting-list entry claims
// that seat_number (assigned, not physically seated yet), 2 = an active/seated entry
// (out_time null, not waiting) claims it. entries here is already the ACTIVE/seated
// list for the selected table; waiting is that table's queue.
const SEAT_NUMBERS = Array.from({ length: 10 }, (_, i) => i + 1);
function SeatMap({ entries, waiting }) {
  const seatedBySeat = new Map(entries.filter((e) => e.seat_number).map((e) => [e.seat_number, e]));
  const waitingBySeat = new Map(waiting.filter((w) => w.seat_number).map((w) => [w.seat_number, w]));

  return (
    <>
      <div className="lb-seatmap-legend">
        <span><i style={{ background: "#333846" }} />0 — Empty</span>
        <span><i style={{ background: "#ffcf7b" }} />1 — Assigned, not seated</span>
        <span><i style={{ background: "#7be0a0" }} />2 — Seated</span>
      </div>
      <div className="lb-seatmap">
        {SEAT_NUMBERS.map((n) => {
          const seated = seatedBySeat.get(n);
          const assigned = waitingBySeat.get(n);
          const status = seated ? 2 : assigned ? 1 : 0;
          const occupant = seated || assigned;
          return (
            <div
              key={n}
              className={`lb-seat lb-seat-${status}`}
              title={occupant ? `${occupant.player_id}${occupant.player_name ? " · " + occupant.player_name : ""}` : "Empty seat"}
            >
              <div className="lb-seat-num">Seat {n}</div>
              {occupant && <div className="lb-seat-name">{occupant.player_name || occupant.player_id}</div>}
            </div>
          );
        })}
      </div>
    </>
  );
}

/* ───────────────────────── History Tab ───────────────────────── */
function HistoryTab({ api, showToast }) {
  const [entries, setEntries] = useState([]);
  const [waiting, setWaiting] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterTable, setFilterTable] = useState("");
  const [filterPlayer, setFilterPlayer] = useState("");
  const [selectedTableNumber, setSelectedTableNumber] = useState(null);
  const [editing, setEditing] = useState(null);

  const load = useCallback(async (silent = false) => {
    if (!silent) setLoading(true);
    const params = new URLSearchParams({ size: "30" });
    if (selectedTableNumber) {
      params.set("table_number", selectedTableNumber);
      params.set("status", "ACTIVE");
    } else {
      if (filterTable) params.set("table_type", filterTable);
      if (filterPlayer.trim()) params.set("player_id", filterPlayer.trim());
    }
    const [entriesRes, waitingRes] = await Promise.all([
      api("get", `/leaderboard/entries?${params.toString()}`),
      selectedTableNumber ? api("get", `/leaderboard/waiting?table_number=${selectedTableNumber}`) : Promise.resolve({ ok: true, payload: { entries: [] } }),
    ]);
    if (entriesRes.ok) setEntries(entriesRes.payload?.entries || []);
    if (waitingRes.ok) setWaiting(waitingRes.payload?.entries || []);
    if (!silent) setLoading(false);
  }, [api, filterTable, filterPlayer, selectedTableNumber]);

  useEffect(() => { load(); }, [load]);

  // Keep the "who's live on this table" view fresh without a reload flicker.
  useEffect(() => {
    if (!selectedTableNumber) return;
    const id = setInterval(() => load(true), 10000);
    return () => clearInterval(id);
  }, [selectedTableNumber, load]);

  const onDelete = async (id) => {
    if (!window.confirm("Delete this entry?")) return;
    const { ok, payload } = await api("delete", `/leaderboard/entries/${id}`);
    if (!ok || !payload?.status) return showToast(payload?.message || "Delete failed", true);
    showToast("Entry deleted");
    load();
  };

  const onCheckout = async (id) => {
    const { ok, payload } = await api("patch", `/leaderboard/entries/${id}/checkout`);
    if (!ok || !payload?.status) return showToast(payload?.message || "Checkout failed", true);
    const next = payload?.next_waiting;
    showToast(next
      ? `Checked out. Next in line for Table ${next.table_number}: ${next.player_name || next.player_id} (waiting since ${fmtTime(next.in_time)})`
      : "Checked out");
    load();
  };

  const onToggleBreak = async (id) => {
    const { ok, payload } = await api("patch", `/leaderboard/entries/${id}/break`);
    if (!ok || !payload?.status) return showToast(payload?.message || "Could not update break", true);
    showToast(payload?.message || "Updated");
    load();
  };

  const onSeat = async (id) => {
    const { ok, payload } = await api("patch", `/leaderboard/entries/${id}/seat`);
    if (!ok || !payload?.status) return showToast(payload?.message || "Could not seat player", true);
    showToast(`${payload?.data?.player_name || payload?.data?.player_id || "Player"} seated`);
    load();
  };

  const toggleTable = (n) => setSelectedTableNumber((cur) => (cur === n ? null : n));
  const tableFull = selectedTableNumber && entries.length >= TABLE_CAPACITY;

  return (
    <div>
      <div className="lb-table-bar">
        {TABLE_NUMBERS.map((n) => (
          <button
            key={n}
            className={`lb-table-btn${selectedTableNumber === n ? " active" : ""}`}
            onClick={() => toggleTable(n)}
          >
            Table {n}
          </button>
        ))}
      </div>
      {selectedTableNumber && (
        <div className={`lb-table-live-banner${tableFull ? " full" : ""}`}>
          <span>● Table {selectedTableNumber}: {entries.length}/{TABLE_CAPACITY} seated{waiting.length ? ` · ${waiting.length} waiting` : ""}</span>
          <button onClick={() => setSelectedTableNumber(null)}>Show all history</button>
        </div>
      )}
      {selectedTableNumber && <SeatMap entries={entries} waiting={waiting} />}
      {selectedTableNumber && waiting.length > 0 && (
        <>
          <div className="lb-section-title">Waiting for Table {selectedTableNumber}</div>
          {waiting.map((w, i) => (
            <div className="lb-wait-row" key={w._id}>
              <div className="lb-wait-info">
                <div className="lb-wait-name"><span className="lb-wait-pos">#{i + 1}</span>{w.player_id}{w.player_name ? ` · ${w.player_name}` : ""}</div>
                <div className="lb-wait-sub">Waiting since {fmtTime(w.in_time)}</div>
              </div>
              {entries.length < TABLE_CAPACITY && (
                <button className="lb-act-seat" onClick={() => onSeat(w._id)}>Seat Now</button>
              )}
            </div>
          ))}
        </>
      )}
      {selectedTableNumber && waiting.length > 0 && <div className="lb-section-title">Seated</div>}
      {!selectedTableNumber && (
      <div className="lb-filters">
        <input placeholder="Filter by Player ID" value={filterPlayer} onChange={(e) => setFilterPlayer(e.target.value)} />
        <select value={filterTable} onChange={(e) => setFilterTable(e.target.value)}>
          <option value="">All tables</option>
          {TABLE_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>
      )}
      {loading ? (
        <div className="lb-empty">Loading…</div>
      ) : !entries.length ? (
        <div className="lb-empty">{selectedTableNumber ? `No one currently seated on Table ${selectedTableNumber}.` : "No entries found."}</div>
      ) : (
        entries.map((e) => {
          const duration = e.out_time ? (new Date(e.out_time) - new Date(e.in_time)) / 60000 - (e.break_minutes || 0) : null;
          return (
            <div className="lb-entry" key={e._id}>
              <div className="lb-entry-top">
                <div>
                  <div className="lb-entry-player">{e.player_id}{e.player_name ? ` · ${e.player_name}` : ""}</div>
                  <div className="lb-entry-sub">{fmtTime(e.in_time)} → {e.out_time ? fmtTime(e.out_time) : "ongoing"}</div>
                </div>
                <span className={`lb-chip${e.is_waiting ? " lb-chip-break" : e.out_time ? "" : " lb-chip-live"}`}>{e.is_waiting ? "Waiting" : e.out_time ? "Completed" : "Live"}</span>
              </div>
              <div className="lb-entry-meta">
                <span>Table: {e.table_type}{e.table_value ? ` · ${e.table_value}` : ""}{e.table_number ? ` (#${e.table_number})` : ""}{e.seat_number ? ` · Seat ${e.seat_number}` : ""}</span>
                {e.seat_number && !e.out_time && (
                  <span className={`lb-chip${e.is_waiting ? " lb-chip-break" : " lb-chip-live"}`}>
                    {e.is_waiting ? "Not Seated Yet" : "Seated"}
                  </span>
                )}
                {!e.is_waiting && <span>Break: {e.break_minutes || 0}m</span>}
                {duration != null && <span>Played: {fmtDuration(duration)}</span>}
                {!e.out_time && !e.is_waiting && e.break_started_at && <span className="lb-chip lb-chip-break">⏸ On Break</span>}
              </div>
              <div className="lb-entry-actions">
                {e.is_waiting && !e.out_time && (
                  <button className="lb-act-seat" onClick={() => onSeat(e._id)}>Seat Now</button>
                )}
                {!e.out_time && !e.is_waiting && (
                  <>
                    <button className="lb-act-checkout" onClick={() => onCheckout(e._id)}>Checkout</button>
                    <button
                      className={`lb-act-break${e.break_started_at ? " on-break" : ""}`}
                      onClick={() => onToggleBreak(e._id)}
                    >
                      {e.break_started_at ? "End Break" : "Start Break"}
                    </button>
                  </>
                )}
                <button className="lb-act-edit" onClick={() => setEditing(e)}>Edit</button>
                <button className="lb-act-del" onClick={() => onDelete(e._id)}>Delete</button>
              </div>
            </div>
          );
        })
      )}
      {editing && (
        <EditModal
          entry={editing}
          api={api}
          onClose={() => setEditing(null)}
          onDone={() => { setEditing(null); load(); showToast("Entry updated"); }}
        />
      )}
    </div>
  );
}

function EditModal({ entry, api, onClose, onDone }) {
  const [form, setForm] = useState({
    player_id: entry.player_id,
    table_type: entry.table_type,
    table_value: entry.table_value || TABLE_VALUES[0],
    table_number: entry.table_number || TABLE_NUMBERS[0],
    seat_number: entry.seat_number ? String(entry.seat_number) : "",
    in_time: toInputValue(entry.in_time),
    out_time: entry.out_time ? toInputValue(entry.out_time) : "",
    break_minutes: String(entry.break_minutes || 0),
  });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const playerIdChanged = form.player_id.trim() !== entry.player_id;
  const { status: playerStatus, player: matchedPlayer } = usePlayerLookup(api, playerIdChanged ? form.player_id : "");

  const submit = async () => {
    if (form.out_time && fromInputValue(form.out_time) <= fromInputValue(form.in_time)) {
      return setErr("Out-time must be after in-time");
    }
    if (playerIdChanged && playerStatus !== "valid") {
      return setErr("Enter a valid Player ID before saving");
    }
    if (form.seat_number && (Number(form.seat_number) < 1 || Number(form.seat_number) > 10)) {
      return setErr("Seat number must be between 1 and 10");
    }
    setSaving(true);
    const { ok, payload } = await api("put", `/leaderboard/entries/${entry._id}`, {
      player_id: form.player_id.trim(),
      table_type: form.table_type,
      table_value: form.table_value,
      table_number: form.table_number,
      seat_number: form.seat_number ? Number(form.seat_number) : null,
      in_time: fromInputValue(form.in_time).toISOString(),
      out_time: form.out_time ? fromInputValue(form.out_time).toISOString() : null,
      break_minutes: Number(form.break_minutes) || 0,
    });
    setSaving(false);
    if (!ok || !payload?.status) return setErr(payload?.message || "Could not update");
    onDone();
  };

  return (
    <div className="lb-modal-backdrop" onClick={onClose}>
      <div className="lb-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Edit Entry</h3>
        <div className="lb-field">
          <label>Player ID</label>
          <input className="lb-input" value={form.player_id} onChange={set("player_id")} />
          {playerIdChanged && <PlayerIdStatusLine status={playerStatus} player={matchedPlayer} />}
        </div>
        <div className="lb-field">
          <label>Table Type</label>
          <select className="lb-select" value={form.table_type} onChange={set("table_type")}>
            {TABLE_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div className="lb-field">
          <label>Table Value</label>
          <select className="lb-select" value={form.table_value} onChange={set("table_value")}>
            {TABLE_VALUES.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
        </div>
        <div className="lb-field">
          <label>Table Number</label>
          <select className="lb-select" value={form.table_number} onChange={set("table_number")}>
            {TABLE_NUMBERS.map((n) => <option key={n} value={n}>Table {n}</option>)}
          </select>
        </div>
        <div className="lb-field">
          <label>Seat Number</label>
          <input
            className="lb-input"
            type="text"
            inputMode="numeric"
            placeholder="1-10"
            value={form.seat_number}
            onChange={(e) => {
              const v = e.target.value.replace(/[^0-9]/g, "");
              setForm((f) => ({ ...f, seat_number: v === "" ? "" : String(Math.min(10, Number(v))) }));
            }}
          />
        </div>
        <div className="lb-row2">
          <div className="lb-field">
            <label>In-Time</label>
            <input className="lb-input" type="datetime-local" value={form.in_time} onChange={set("in_time")} />
          </div>
          <div className="lb-field">
            <label>Out-Time</label>
            <input className="lb-input" type="datetime-local" value={form.out_time} onChange={set("out_time")} />
          </div>
        </div>
        <div className="lb-field">
          <label>Break (minutes)</label>
          <input className="lb-input" type="number" min="0" value={form.break_minutes} onChange={set("break_minutes")} />
        </div>
        {err && <div className="lb-login-err" style={{ marginBottom: 10 }}>{err}</div>}
        <div style={{ display: "flex", gap: 10 }}>
          <button className="lb-btn lb-btn-ghost" onClick={onClose} type="button">Cancel</button>
          <button className="lb-btn lb-btn-primary" onClick={submit} disabled={saving || (playerIdChanged && playerStatus !== "valid")} type="button">
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ───────────────────────── Rankings Tab ───────────────────────── */
function RankingsTab({ api }) {
  const todayStart = () => toInputValue().slice(0, 10) + "T00:00";
  const [dateFrom, setDateFrom] = useState(todayStart());
  const [dateTo, setDateTo] = useState(toInputValue());
  const [rankings, setRankings] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async (silent = false) => {
    if (!silent) setLoading(true);
    const params = new URLSearchParams();
    if (dateFrom) params.set("date_from", fromInputValue(dateFrom).toISOString());
    if (dateTo) params.set("date_to", fromInputValue(dateTo).toISOString());
    const { ok, payload } = await api("get", `/leaderboard/rankings?${params.toString()}`);
    if (ok) setRankings(payload?.rankings || []);
    if (!silent) setLoading(false);
  }, [api, dateFrom, dateTo]);

  useEffect(() => { load(); }, [load]);

  // Live sessions accrue points in real time — keep the ranking fresh without a full reload flicker.
  useEffect(() => {
    const id = setInterval(() => load(true), 20000);
    return () => clearInterval(id);
  }, [load]);

  const medalClass = (i) => (i === 0 ? " gold" : i === 1 ? " silver" : i === 2 ? " bronze" : "");

  return (
    <div>
      <div className="lb-card">
        <div className="lb-row2">
          <div className="lb-field" style={{ marginBottom: 0 }}>
            <label>From</label>
            <input className="lb-input" type="datetime-local" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
          </div>
          <div className="lb-field" style={{ marginBottom: 0 }}>
            <label>To</label>
            <input className="lb-input" type="datetime-local" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
          </div>
        </div>
      </div>
      <div className="lb-card lb-rules-card">
        <div className="lb-rules-title">Points = Minutes Played × Table Multiplier</div>
        <div className="lb-rules-mult">
          {Object.entries(TABLE_MULTIPLIERS).map(([t, m]) => (
            <span key={t} className="lb-chip">{t} · {m}x</span>
          ))}
        </div>
        <div className="lb-rules-note">Live sessions count in real time</div>
      </div>
      {loading ? (
        <div className="lb-empty">Loading…</div>
      ) : !rankings.length ? (
        <div className="lb-empty">No qualifying sessions in this range.</div>
      ) : (
        rankings.map((r, i) => (
          <div className="lb-rank-row" key={r._id}>
            <div className={`lb-rank-num${medalClass(i)}`}>{i + 1}</div>
            <div className="lb-rank-info">
              <div className="lb-rank-name">
                {r._id}{r.player_name ? ` · ${r.player_name}` : ""}
                {r.is_live && <span className="lb-chip lb-chip-live" style={{ marginLeft: 8 }}>● LIVE</span>}
              </div>
              <div className="lb-rank-sub">{fmtDuration(r.total_minutes)} · {r.session_count} session{r.session_count > 1 ? "s" : ""} · {(r.table_types || []).join(", ")}</div>
            </div>
            <div className="lb-rank-time">{fmtPoints(r.total_points)} pts</div>
          </div>
        ))
      )}
    </div>
  );
}
